<template>
  <div class="flex w-full h-full">
    <div class="flex flex-col items-center justify-center w-full min-h-full" v-if="!port || !getBerths.length">
      <svg width="320" height="160" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M34.59 121.467c-.195-.107-.442-.249-.61-.399-1.596-1.421-3.707-1.427-5.31 0-1.056.941-2.422.941-3.479 0-.784-.698-1.702-1.067-2.654-1.067-.953 0-1.871.369-2.655 1.067-1.057.941-2.423.941-3.48 0-1.596-1.421-3.707-1.427-5.31 0a3.297 3.297 0 01-.668.43c-.367.189-.526.674-.356 1.083.17.408.606.586.973.396.41-.212.718-.414.967-.636 1.057-.941 2.423-.941 3.48 0 1.596 1.421 3.707 1.427 5.309 0 1.057-.941 2.422-.941 3.48 0 1.596 1.421 3.707 1.427 5.309 0 1.057-.941 2.422-.941 3.48 0 .277.247.6.436.878.589.363.199.802.032.98-.372.18-.404.03-.892-.334-1.091zM52.41 72.467c.195-.107.442-.25.61-.399 1.596-1.421 3.707-1.427 5.31 0 1.056.941 2.422.941 3.479 0 .784-.698 1.702-1.067 2.654-1.067.953 0 1.871.369 2.655 1.067 1.057.941 2.423.941 3.48 0 1.596-1.421 3.707-1.427 5.31 0 .152.136.37.276.668.43.367.19.526.674.356 1.083-.17.408-.606.585-.973.396-.41-.212-.718-.414-.967-.636-1.057-.94-2.422-.941-3.48 0-1.596 1.422-3.707 1.427-5.309 0-1.057-.94-2.422-.941-3.48 0-1.596 1.422-3.707 1.427-5.309 0-1.057-.94-2.422-.941-3.48 0-.277.247-.6.436-.878.59-.363.198-.802.031-.98-.373-.18-.404-.03-.892.334-1.091z" fill="#DEE3EA"/><path fill-rule="evenodd" clip-rule="evenodd" d="M32 31.2a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4zm0 1.8a3 3 0 100-6 3 3 0 000 6zM299 120.8a1.2 1.2 0 100 2.4 1.2 1.2 0 000-2.4zm0-1.8a3 3 0 100 6 3 3 0 000-6z" fill="#DEE3EA"/><path d="M281.409 27.467c.196-.107.443-.25.611-.399 1.596-1.421 3.707-1.427 5.309 0 1.057.941 2.423.941 3.48 0 .784-.698 1.702-1.067 2.654-1.067.953 0 1.871.369 2.655 1.067 1.057.941 2.423.941 3.48 0 1.596-1.421 3.707-1.427 5.309 0 .153.136.371.276.669.43.367.19.526.674.356 1.083-.17.408-.606.585-.973.396-.411-.212-.718-.414-.967-.636-1.057-.94-2.423-.941-3.479 0-1.597 1.421-3.708 1.427-5.31 0-1.057-.94-2.422-.941-3.479 0-1.597 1.421-3.708 1.427-5.31 0-1.057-.94-2.422-.941-3.479 0a4.75 4.75 0 01-.879.59c-.363.198-.802.031-.981-.373-.178-.404-.029-.892.334-1.091zM237.409 69.467c.196-.107.443-.25.611-.399 1.596-1.421 3.707-1.427 5.309 0 1.057.941 2.423.941 3.48 0 .784-.698 1.702-1.067 2.654-1.067.953 0 1.871.369 2.655 1.067 1.057.941 2.423.941 3.48 0 1.596-1.421 3.707-1.427 5.309 0 .153.136.371.276.669.43.367.19.526.674.356 1.083-.17.408-.606.585-.973.396-.411-.212-.718-.414-.967-.636-1.057-.94-2.423-.941-3.479 0-1.597 1.422-3.708 1.427-5.31 0-1.057-.94-2.422-.941-3.479 0-1.597 1.422-3.708 1.427-5.31 0-1.057-.94-2.422-.941-3.479 0a4.75 4.75 0 01-.879.59c-.363.198-.802.031-.981-.373-.178-.404-.029-.892.334-1.091z" fill="#DEE3EA"/><path fill-rule="evenodd" clip-rule="evenodd" d="M135.5 23a1 1 0 011-1H183a1 1 0 011 1v8.5h18a1 1 0 01.971.761l15 61c.019.078.029.159.029.239v43a1 1 0 01-1 1H103a1 1 0 01-1-1v-43c0-.08.01-.16.029-.239l15-61A1 1 0 01118 31.5h17.5V23zm0 10.5h-16.716l-14.508 59H121.5v-22a1 1 0 011-1h6V47a1 1 0 011-1h6V33.5zm2 12.5H182V24h-44.5v22zm46.5 0h6a1 1 0 011 1v22.5h6a1 1 0 011 1v22h17.724l-14.508-59H184V46zm32 48.5h-34.337l-5.242 12.39a1 1 0 01-.921.61H145a1 1 0 01-.921-.61l-5.242-12.39H104v41h112v-41zm-20-2v-21h-72.5v21h16a1 1 0 01.921.61l5.242 12.39h29.174l5.242-12.39a1 1 0 01.921-.61h15zm-7-23V48h-58.5v21.5H189zm-45 52a1 1 0 011-1h30.5a1 1 0 010 2H145a1 1 0 01-1-1z" fill="#DEE3EA"/></svg>
      <h1 class="m-t-4 m-b-2 fz18 fw500">Archive is empty</h1>
    </div>

    <div class="w-1/3 overflow-y-auto box-border border-r border-gray-light bg-white" v-if="port && getBerths.length">
      <aside-top :name="port.name"/>
      <aside-list 
        :list="getBerths" 
        :active="active" 
        @on-select="onSelectBerth"
        @on-archive="onArchive"
      />
    </div>
    <div class="w-2/3 overflow-y-auto box-border" v-if="port && getBerths.length">
      <div class="flex items-center justify-between p-x-6 p-y-4">
        <h2 class="fz18 fw500">Berth Details</h2>
        <div class="fz13 text-gray-text" v-if="active">Last edit {{active.updated_at | formatDate}} at {{active.updated_at | formatTime}} {{active.creator ? 'by '+active.creator.first_name+' '+active.creator.last_name : ''}}</div>
        <div class="fz13 text-gray-text" v-else>Please, choose the berth</div>
      </div>

      <berth class="m-x-6 m-b-4" v-if="active" :berth="active"/>
    </div>

    <archive-modal 
      :isShowModal="isModalArchive"
      :berth="archivedBerth"
      @on-close="onCloseModal"
      @on-send="sendArchive"
    ></archive-modal>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

import asideTop from '@/components/ports/berth/asideTop'
import asideList from '@/components/ports/berth/asideList'
import berth from '@/components/ports/berth/berth'
import archiveModal from '@/components/ports/berth/modal'

export default {
  components: {
    asideTop,
    asideList,
    berth,
    archiveModal
  },
  data() {
    return {
      active: null,
      isModalArchive: false,
      archivedBerth: null
    }
  },
  computed: {
    ...mapState({
      port: state => state.ports.openPort
    }),
    getBerths() {
      if(!this.port || !this.port.berths.length) return []
      return this.port.berths.filter(el=>el.is_archive)
    }
  },
  methods: {
    ...mapActions(['axiosEditBerth']),
    ...mapMutations(['addTip']),
    onSelectBerth(berth) {
      this.active = berth
    },
    onCloseModal() {
      this.isModalArchive = false
      this.archivedBerth = null
    },
    onArchive(berth) {
      this.archivedBerth = berth
      this.isModalArchive = true
    },
    async onUpdate(berth) {
      if(berth.port.id)
        berth.port = berth.port.id

      let newBerth = await this.axiosEditBerth({...berth})

      let index = this.port.berths.findIndex(el=>{
        return el.id == newBerth.id
      })
      this.port.berths.splice(index, 1, newBerth)
    },
    async sendArchive() {
      this.archivedBerth.is_archive = false
      this.onUpdate(this.archivedBerth)
      this.addTip(this.archivedBerth.name + ` is unarchived`)
      if(this.active && this.active.id == this.archivedBerth.id) this.active = null
      this.archivedBerth = null
      this.isModalArchive = false
    }
  }
}
</script>

<style>

</style>